import { IACDLEvent } from '../../../../../services/eventBus.service';

export const SegmentationDeselectedEventType = Symbol('SEGMENTATION_DESELECTED_EVENT');

export class SegmentationDeselectedEvent implements IACDLEvent {
  get type(): symbol {
    return SegmentationDeselectedEventType;
  }
}
